const steps = [
  {
    num: '01',
    word: 'THINK.',
    desc: 'We don\'t start with tools. We start with questions — until the problem is clear.',
  },
  {
    num: '02',
    word: 'SHAPE.',
    desc: 'Architecture. Flow. Interface. Every decision earns its place. Nothing is decoration.',
  },
  {
    num: '03',
    word: 'BUILD.',
    desc: 'Clean code. Clear structure. No shortcuts. No excuses. Built to last.',
  },
  {
    num: '04',
    word: 'SHIP.',
    desc: 'We launch — then stay. Iterate until it works the way it should.',
  },
];

export default function Process() {
  return (
    <section className="section section--divider" id="process">

      {/* ── HEADER ── */}
      <div className="process__header">
        <div>
          <div className="section__label">05 — PROCESS</div>
          <h2 className="section__headline">HOW<br />WE WORK.</h2>
        </div>
        <p className="section__sub process__intro">
          Great products aren't built fast.<br />
          They're built right — through discipline,<br />
          care, and relentless iteration.
        </p>
      </div>

      {/* ── STEPS GRID ── */}
      <div className="process__steps">
        {steps.map((step) => (
          <div className="process__step" key={step.num}>
            <span className="process__step-num">{step.num}</span>
            <div className="process__step-word">{step.word}</div>
            <p className="process__step-desc">{step.desc}</p>
          </div>
        ))}
      </div>

    </section>
  );
}
